const ACTION = {
    UPDATE_HISTORICAL_MAIL_SUBJECT: 'UPDATE_HISTORICAL_MAIL_SUBJECT',
    UPDATE_HISTORICAL_MAIL_SUBJECT_ERROR_TEXT: 'UPDATE_HISTORICAL_MAIL_SUBJECT_ERROR_TEXT',
    UPDATE_HISTORICAL_MAIL_SUBJECT_ERROR_TEXT_BY_INDEX: 'UPDATE_HISTORICAL_MAIL_SUBJECT_ERROR_TEXT_BY_INDEX'
}

export default ACTION;